import getMuiTheme from 'material-ui/styles/getMuiTheme'
import {
  yellow900,
  grey100,
  grey300,
  grey400,
  grey500,
  white,
  darkBlack,
  fullBlack,
} from 'material-ui/styles/colors'
import { fade } from 'material-ui/utils/colorManipulator'
import { merge } from 'lodash'

import { getTheme } from './selectors'
import content from '../content'

const defaultTheme = {
  palette: {
    primary1Color: '#143278',
    primary2Color: '#0f275e',
    primary3Color: grey400,
    accent1Color: yellow900,
    accent2Color: grey100,
    accent3Color: grey500,
    textColor: darkBlack,
    alternateTextColor: white,
    canvasColor: white,
    borderColor: grey300,
    disabledColor: fade(darkBlack, 0.3),
    pickerHeaderColor: '#143278',
    clockCircleColor: fade(darkBlack, 0.07),
    shadowColor: fullBlack,
  },
  custom: {
    colors: {
      backgroundColor: 'pink',
      textInputBackgroundColor: 'rgba(153,153,153,0.2)',
    },
    metrics: {
      // base template padding
      basePadding: 10, // TODO: shouldn't depend on css files
      maxContentWidth: 800,
      tabNavigationHeight: 48,
    },
  },
}

const contentTheme = getTheme(content)

export const muiTheme = getMuiTheme(merge(defaultTheme, contentTheme))



// WEBPACK FOOTER //
// ./src/app/theme.js